import React, { useState } from 'react'
import i18n from 'i18n-js'
import Flag from 'react-world-flags'
import { ImCircleDown } from 'react-icons/im'

import './SidebarLanguage.scss'

const SidebarLanguage = () => {

    const [languageMenuOpen, setLanguageMenuOpen] = useState(false)

    const translations = Object.keys(i18n.translations)
    const languages = translations.map(el => {

        let flag = null
        let text = null

        switch (el) {
            case 'en':
                flag = 'GB'
                text = 'English'
                break
            case 'es':
                flag = 'ES'
                text = 'Español'
                break
            case 'it':
                flag = 'IT'
                text = 'Italiano'
                break
            case 'fr':
                flag = 'FR'
                text = 'Français'
                break
            case 'de':
                flag = 'DE'
                text = 'Deutsche'
                break
            case 'ja':
                flag = 'JP'
                text = '日本語'
                break
            case 'zh':
                flag = 'CN'
                text = '中文'
                break
            case 'ko':
                flag = 'KR'
                text = '한국어'
                break
            default:
                console.log('flag switch not found', el)
                break
        }

        return {
            language: el,
            flag: flag,
            text: text
        }
    })

    const selected = languages.find(el => el.language === i18n.locale)

    const onSetLanguage = lang => {
        console.log('onSetLanguage', lang)
        localStorage.setItem('EHPLanguage', lang)
        window.location.reload()
    }

    return <div className="SidebarLanguage">
        <div className="default-container">
            <div>{i18n.t('label_language')}</div>
            <div className="btn-default btn-flag" role="button" onClick={() => setLanguageMenuOpen(!languageMenuOpen)}>
                <span>{i18n.t('language_name')}</span>
                <Flag code={selected.flag} />
                <ImCircleDown size="1rem" />
            </div>
        </div>

        {languageMenuOpen && <div className="default-container">
            <span className="just-a-spacer-for-flexbox-bleah" />
            <ul className="languages-list" role="combobox">
                {languages.map(lang => {
                    return <li key={lang.language} onClick={() => onSetLanguage(lang.language)}>
                        <span>{lang.text}</span>
                        <Flag code={lang.flag} />
                    </li>
                })}
            </ul>
        </div>}
    </div>
}

export default SidebarLanguage